import React from 'react';
import ApiProyectos from '../mis-proyectos/ApiProyectos';
import Header from '../nav/Header';
import Title from '../nav/Title';
import Footer from './Footer';
import '../../assets/css/Proyecto.css'


const Proyectos = () => {
  return (
    <>
    <Title title='Proyectos' />
    <body id="proyectos">
    <Header/>
        <main className="container">
        <div className="row">
            <div className="col-12 mb-3 mt-3">
                <h1>Proyectos</h1>
            </div>
        </div>
        <div className="row">
            <div className="col-12">
                <p>Los siguientes son algunos de los trabajos que he realizado:</p>
            </div>
        </div>
    
        <ApiProyectos/>
        
    </main>

         <Footer/>
         </body>
    </>
  )
}

export default Proyectos